import React from 'react'

import {
  faAward,
  faBookmark,
  faCalendar,
  faCalendarAlt,
  faClipboardCheck,
  faCompass,
  faEnvelope,
  faFile,
  faHashtag,
  faHomeAlt,
  faPlusCircle,
  faPresentation,
  faPuzzlePiece,
  faSparkle,
  faUser,
} from '@fortawesome/pro-regular-svg-icons'
import { get } from 'lodash'

import { EVENT_CLICK_SOURCES } from 'common/track-event-constants'
import ScoirApplyIcon from 'components/HeaderNavigation/Navigation/components/ScoirApplyIcon'

const hrp = (str) => `${import.meta.env.BASE_URL}/${str}`

export const results = {
  // This is the list of the preset TypeAheadSearch items
  dashboard: {
    to: hrp('dashboard'),
    label: 'Home',
    icon: faHomeAlt,
    id: 'dashboard',
  },
  discover: {
    to: hrp('discover'),
    label: 'Discover',
    icon: faCompass,
    id: 'discover',
  },
  myColleges: {
    to: hrp('my-colleges'),
    label: 'My Colleges',
    icon: faBookmark,
    id: 'myColleges',
    filteredBy: (obj) => get(obj, 'canShowMyColleges', true),
  },
  recsDocs: {
    to: hrp('my-colleges/documents'),
    label: 'Recs & Docs',
    icon: faFile,
    id: 'recsDocs',
    filteredBy: (obj) => get(obj, 'canShowMyColleges', true),
  },
  messageCenter: {
    to: hrp('message-center/outreach'),
    label: 'Message Center',
    icon: faEnvelope,
    id: 'messageCenter',
    filteredBy: (obj) => get(obj, 'canShowMessages', true),
  },
  myMatches: {
    to: hrp('discover/for-you/my-matches'),
    label: 'My Matches',
    icon: faPuzzlePiece,
    id: 'myMatches',
    filteredBy: (obj) => get(obj, 'canShowApplyWithScoir', true),
  },
  myProfile: {
    to: hrp('profile'),
    label: 'My Profile',
    icon: faUser,
    id: 'myProfile',
  },
  applications: {
    to: hrp('app-profile'),
    label: 'Apply with Scoir',
    iconComp: <ScoirApplyIcon />,
    id: 'applications',
    filteredBy: (obj) => get(obj, 'canShowApplyWithScoir', true),
  },
  visitsDeadlines: {
    to: hrp('events'),
    label: 'Visits & Deadlines',
    icon: faCalendarAlt,
    id: 'eventsDeadlines',
    filteredBy: (obj) => get(obj, 'canShowVisitsAndDeadlines', true),
  },
  surveys: {
    to: hrp('surveys'),
    label: 'Surveys',
    icon: faClipboardCheck,
    id: 'surveys',
    filteredBy: (obj) => get(obj, 'hasHighSchool', false) && get(obj, 'canShowSurveys', true),
  },
  sessions: {
    to: hrp('sessions'),
    label: 'College Sessions',
    icon: faPresentation,
    id: 'sessions',
    filteredBy: (obj) => get(obj, 'canSupportSessions', true),
  },
  compare: {
    to: hrp('college-compare'),
    label: 'Compare Colleges',
    icon: faPlusCircle,
    id: 'compare',
  },
  events: {
    to: hrp(`discover/events?source=${EVENT_CLICK_SOURCES.TYPE_AHEAD_SEARCH}`),
    label: 'Upcoming Events',
    icon: faCalendar,
    id: 'events',
    filteredBy: (obj) => get(obj, 'canShowUpcomingEvents', true),
  },
  posts: {
    to: hrp('discover/posts'),
    label: 'Posts',
    icon: faHashtag,
    id: 'posts',
  },
  programs: {
    to: hrp(`discover/programs?source=${EVENT_CLICK_SOURCES.TYPE_AHEAD_SEARCH}`),
    label: 'Pre-College Programs',
    icon: faAward,
    id: 'programs',
  },
  nlp: {
    to: hrp(`discover/search?source=${EVENT_CLICK_SOURCES.NLP_COLLEGE_GLOBAL_SEARCH}`),
    icon: faSparkle,
    label: 'Search Colleges',
    id: 'nlp',
  },
}

export default results
